import ProductSwiper from "components/commonComponent/productSwiper";
import useNewProducts from "hook/useNewProduct";
import newIcon from "images/newProduct.png";
import { useSettings } from "context/SettingsContext";
import { t } from "context/translations";
const NewProducts = () => {
  const { newProducts, loading1 } = useNewProducts();
  const { language } = useSettings();
  return (
    <div>
      <ProductSwiper
        data={newProducts}
        loading={loading1}
        link="/allNewProduct"
        title={t("newProducts", language)}
        icon={newIcon}
      />
    </div>
  );
};

export default NewProducts;
